import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { Integration } from 'lib/types';
import { RootState } from 'reducers';

import IntegrationEditor from 'components/IntegrationEditor/IntegrationEditor';

import 'styles.scss';
import { useEffect, useCallback } from 'react';
import Button from 'components/Button/Button';

function IntegrationEditPage() {
    const navigate = useNavigate();
    const { integrationId } = useParams();

    const integration: Integration = useSelector(
        (state: RootState) => state.integrations.byId[integrationId]
    );
    const isNewIntegration = integration == null;

    useEffect(() => {
        if (integrationId != null && isNewIntegration) {
            navigate('/integrations/create-integration', { replace: true });
        }
    }, [integrationId, isNewIntegration, navigate]);

    const handleBackClicked = useCallback(() => {
        navigate('/integrations');
    }, [navigate]);

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex flex-row justify-content-between align-items-start">
                        <h1 className="msds-text-header-1 msds-text-clear-blue mb-10">
                            Integration Registration
                        </h1>
                        <Button color="secondary" className="mb-4 mt-0" type="button" onClick={handleBackClicked}>
                            Back to integrations
                        </Button>
                    </div>
                    <p>To retrieve the license information XML, please download the <a href="https://download.milestonesys.com/MIPSDK/LicenseRegistrationInstaller.msi">XProtect License Registration plug-in</a>.</p>
                    <IntegrationEditor integration={integration} />
                </div>
            </div>
        </div>           
    );
}

export default IntegrationEditPage;
